import { createColumnHelper } from '@tanstack/react-table';

import { History } from 'types/history';
import { Site } from 'types/site';
import { Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';
import getSiteNameBySiteID from 'utils/getSiteNameBySiteID';

const col = createColumnHelper<History>();

/** Items history relabels two statuses: OPEN shows as NEW, CLOSE as END. */
const renderStatus = (status: number) => {
  if (status === 0) {
    return 'NEW';
  }

  if (status === 12) {
    return 'END';
  }

  return Status[status];
};

const showVenue = (history: History, allSites: Site[]) => {
  if (history) {
    return getSiteNameBySiteID(history?.item?.currentVenue, allSites);
  }

  return ' - ';
};

export const buildItemsHistoryColumns = (allSites: Site[]) => [
  col.accessor(
    (history) =>
      `${history?.scanPerformedBy?.fname || ''} ${
        history?.scanPerformedBy?.lname || ''
      }`,
    { id: 'scanPerformedBy', header: 'Scan Performed By', minSize: 250 },
  ),
  col.accessor((history) => renderStatus(history?.status) || '-', {
    id: 'status',
    header: 'Status',
    minSize: 250,
  }),
  col.accessor((history) => history?.washHub?.name || '-', {
    id: 'washHub',
    header: 'Wash Hub',
    minSize: 250,
  }),
  col.accessor((history) => history?.sku?.name || '-', {
    id: 'sku',
    header: 'SKU',
    minSize: 250,
  }),
  col.accessor((history) => convertUTCToLocal(history?.createdAt, true), {
    id: 'createdAt',
    header: 'Created At',
    minSize: 250,
  }),
  col.accessor((history) => (history?.isEPC ? 'Scanned' : 'Manual'), {
    id: 'scanType',
    header: 'Scan Type',
    minSize: 250,
  }),
  col.accessor((history) => showVenue(history, allSites), {
    id: 'venue',
    header: 'Last Venue',
    minSize: 250,
    meta: { align: 'center' },
  }),
];
